import PropTypes from "prop-types";

const Input = (props) => {
  return (
    <input
      className={`input ${props.color}`}
      type={props.type}
      placeholder={props.placeholder}
      value={props.value}
      onChange={props.onChange}
      onKeyDown={props.onKeyDown}
      data-testid={props["data-testid"]}
    />
  );
};

Input.propTypes = {
  color: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  "data-testid": PropTypes.string,
};

export default Input;
